import * as moment from 'moment';
import * as i0 from "@angular/core";
var Clock = /** @class */ (function () {
    function Clock() {
    }
    Clock.getNow = function () {
        var now = moment().toObject();
        return {
            year: now.years,
            month: now.months + 1,
            day: now.date,
            hour: now.hours,
            minute: now.minutes,
            second: now.seconds,
            millisecond: now.milliseconds
        };
    };
    Clock.prototype.now = function () {
        return Clock.getNow();
    };
    Clock.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Clock_Factory() { return new Clock(); }, token: Clock, providedIn: "root" });
    return Clock;
}());
export { Clock };
